var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRename = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12.834,
  height: 12.731,
  viewBox: "0 0 12.834 12.731",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3.997-4h20v20h-20z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#348CFD",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.628 1.872 2.232 2.231-7.034 7.035-3.72 1.488 1.487-3.72 7.035-7.034Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.755.5c.404 0 .808.154 1.117.462.308.309.462.713.462 1.117s-.154.808-.463 1.116L10.755 4.31 8.524 2.08 9.639.962A1.574 1.574 0 0 1 10.755.5Z"
})))));
export { SvgIconRename as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-rename.svg";